import {configureStore, ConfigureStoreOptions} from '@reduxjs/toolkit';
import {mergeDeepRight} from 'ramda';
import {Middleware, ReducersMapObject, combineReducers} from 'redux';

import {isUnitTestMode} from 'config/staticConfig';
import getStore, {isStoreConfigured, setStore} from 'store';

export const dynamicConfigureStore = async (pathname: string) => {
  if (pathname.includes('/quoting')) {
    const store = await import('configure-quoting-store');
    return store.default;
  }
  const appStore = await import('configure-app-store');
  return appStore.default;
};

export const configureReduxStore = (
  reducers: ReducersMapObject<any, any>,
  middleware: Middleware[],
  data: any,
  storedState: any
) => {
  if (!isUnitTestMode && isStoreConfigured()) {
    return getStore();
  }
  const customData = data ? data : {};
  const rootReducer = combineReducers(reducers);
  const reducersInitialState = rootReducer(undefined, {type: 'INIT'});
  const initialState = [reducersInitialState, storedState, customData].reduce(mergeDeepRight);

  const storeOptions: ConfigureStoreOptions = {
    reducer: rootReducer,
    preloadedState: initialState,
    devTools: true,
    middleware
  };
  const store = configureStore(storeOptions);
  setStore(store);
  return store;
};
